import { c as _c } from "react/compiler-runtime";
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
const useProductEFGInternalStatus = () => {
  const $ = _c(3);
  const {
    loading: basicDetailsLoading,
    data: basicDetails
  } = usePDPBasicDetails();
  const t0 = !!(basicDetails?.efg_flag && !basicDetails.is_external);
  let t1;
  if ($[0] !== basicDetailsLoading || $[1] !== t0) {
    t1 = {
      loading: basicDetailsLoading,
      isEFGInternal: t0
    };
    $[0] = basicDetailsLoading;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default useProductEFGInternalStatus;